import {CONTEXT_KEY} from '@/constant';
import {storage} from './storage';

/**
 * 初始化channel list时调用
 * 若当前channel在list中不存在, 则变为auto
 */
export async function setContexts(context = {}) {
  storage.set(CONTEXT_KEY, context);
}

export function getFrontURL() {
  const url = storage.get(CONTEXT_KEY)?.frontUrl ?? '[NA]';
  return url;
}

export function getAdminURL() {
  const url = storage.get(CONTEXT_KEY)?.adminUrl ?? '[NA]';
  return url;
}

export function getDefaultAgent() {
    const agent = storage.get(CONTEXT_KEY)?.defaultAgent ?? undefined;
    return agent;
}

export function getMobiles() {
    const mobiles = storage.get(CONTEXT_KEY)?.mobiles ?? [];
    return mobiles;
}
